import FormField from './FormField';
import { awsCredentialsFields } from './fieldConfigs';
import type { FieldConfig } from './types';

interface AwsCredentialsSectionProps {
    showSessionToken?: boolean;
}

export default function AwsCredentialsSection({ showSessionToken = false }: AwsCredentialsSectionProps) {
    const sessionTokenField: FieldConfig = {
        name: 'sessionToken',
        label: 'Session Token',
        type: 'password',
        placeholder: 'Only for temporary AWS credentials (STS/SSO/assumed role)',
        extra: '⚠️ Required if using temporary AWS credentials (STS, assumed role, or SSO). Leave empty only if using permanent IAM user credentials.',
        isCredential: true,
        keepPlaceholderInEditMode: true,
    };

    return (
        <>
            {awsCredentialsFields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
            {showSessionToken && <FormField config={sessionTokenField} />}
        </>
    );
}
